export enum ClientStatus {
    Active = 0,
    Inactive = 1,
    Deceased = 2,
}

export enum EmailType {
    PatientCommunications = 0,
    LabResults = 1,
    ClientCommunications = 2,
    OverduePayment = 3,
    PhoneCall = 4,
    Registration = 5
}

export enum PatientStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Deceased = 'Deceased',
}

export enum TagType {
    Client = 0,
    Patient = 1,
    Appointment = 2,
    Whiteboard = 3,
    Invoice = 4,
}

export enum CautionStatus {
    Caution = 'Caution',
}

export enum VitalGroupType {
    TPR = 'TPR',
    WaterAndFeces = 'Water and Feces',
    Weight = 'Weight',
}

export enum InputType {
    Number = 'Number',
    Text = 'Text',
    List = 'List',
    Boolean = 'Boolean',
}
